import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { ElementeListeComponent } from './element-liste/elemente-liste/elemente-liste.component';
import { UserListComponent } from './user-list/user-list.component';
import { UserFormComponent } from './user-form/user-form.component';
import { LoginComponent } from './user-login/user-login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthGuard } from '../api-authorization/auth.guard';
import { AdminGuard } from '../api-authorization/AdminGuard';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { UserRegisterComponent } from './user-register/user-register.component';
import { DeviceListComponent } from './device-list/device-list.component';
import { WartungDashboardComponent } from './Wartung/wartung-dashboard/wartung-dashboard.component';
import { CustomerListComponent } from './Wartung/customer-list/customer-list.component';
import { CustomerDetailComponent } from './Wartung/customer-detail/customer-detail.component';
import { MaintenanceDetailComponent } from './Wartung/maintenance-detail/maintenance-detail.component';
import { ServiceCallFormComponent } from './Wartung/service-call-form/service-call-form.component';
import { CommercialBillingComponent } from './Wartung/commercial-billing/commercial-billing.component';
import { SbomListComponent } from './Sbom/sbom-list/sbom-list.component';
import { SbomDetailComponent } from './Sbom/sbom-detail/sbom-detail.component';
import { SecurityAssessmentComponent } from './Sbom/security-assessment/security-assessment.component';
import { BerichteComponent } from './berichte/berichte.component';
import { ResourceTimelineComponent } from './Ressourcenplanung/resource-timeline/resource-timeline.component';
import { ResourcePlanningGuard } from '../api-authorization/ResourcePlanningGuard';
import { StammkundenGuard } from '../api-authorization/StammkundenGuard';
import { MeineEinsaetzeGuard } from '../api-authorization/MeineEinsaetzeGuard';
import { FieldVorarbeiterBlockGuard } from '../api-authorization/FieldVorarbeiterBlockGuard';
import { StammkundenListComponent } from './Stammkunden/stammkunden-list/stammkunden-list.component';
import { StammkundeDetailComponent } from './Stammkunden/stammkunde-detail/stammkunde-detail.component';
import { AuftragDetailComponent } from './Stammkunden/auftrag-detail/auftrag-detail.component';
import { EinsatzPlanungComponent } from './Stammkunden/einsatz-planung/einsatz-planung.component';
import { MeineEinsaetzeComponent } from './Stammkunden/meine-einsaetze/meine-einsaetze.component';



const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, pathMatch: 'full' },
  { path: 'counter', component: CounterComponent },
  { path: 'fetch-data', component: FetchDataComponent },
  { path: 'elemente-liste', component: ElementeListeComponent, canActivate: [AuthGuard] },
  { path: 'users/admindashboard', component: UserListComponent ,canActivate: [AuthGuard] },
  { path: 'users/new', component: UserFormComponent, canActivate: [AuthGuard] },
  { path: 'users/edit/:id', component: UserFormComponent, canActivate: [AuthGuard, AdminGuard] },
  { path: 'users/login', component: LoginComponent },
  { path: 'password-reset', component: ForgotPasswordComponent },
  { path: 'users', component: UserDashboardComponent, canActivate: [AuthGuard] },
  { path: 'changepassword', component: UserRegisterComponent, canActivate: [AuthGuard] },
  { path: 'fullscreen-devices', component: DeviceListComponent, canActivate: [AuthGuard] },
  // Wartung (für den reinen Vorarbeiter gesperrt – nur Lager + Ticketsystem)
  { path: 'wartung', component: WartungDashboardComponent, canActivate: [AuthGuard, FieldVorarbeiterBlockGuard] },
  { path: 'wartung/kunden', component: CustomerListComponent, canActivate: [AuthGuard, FieldVorarbeiterBlockGuard] },
  { path: 'wartung/kunden/:id', component: CustomerDetailComponent, canActivate: [AuthGuard, FieldVorarbeiterBlockGuard] },
  { path: 'wartung/auftrag/:id', component: MaintenanceDetailComponent, canActivate: [AuthGuard, FieldVorarbeiterBlockGuard] },
  { path: 'wartung/einsatz-neu/:customerId', component: ServiceCallFormComponent, canActivate: [AuthGuard, FieldVorarbeiterBlockGuard] },
  { path: 'wartung/einsatz-bearbeiten/:id', component: ServiceCallFormComponent, canActivate: [AuthGuard, FieldVorarbeiterBlockGuard] },
  { path: 'wartung/kaufmaennisch', component: CommercialBillingComponent, canActivate: [AuthGuard, FieldVorarbeiterBlockGuard] },
  // Legacy redirects
  { path: 'wartung/customer-list', redirectTo: '/wartung/kunden', pathMatch: 'full' },
  { path: 'wartung/overview', redirectTo: '/wartung', pathMatch: 'full' },
  // SBOM Management
  { path: 'sbom', component: SbomListComponent, canActivate: [AuthGuard, AdminGuard] },
  { path: 'sbom/projekt/:id', component: SbomDetailComponent, canActivate: [AuthGuard, AdminGuard] },
  { path: 'sbom/projekt/:id/sicherheitscheck', component: SecurityAssessmentComponent, canActivate: [AuthGuard, AdminGuard] },
  // Berichte
  { path: 'berichte', component: BerichteComponent, canActivate: [AuthGuard, AdminGuard] },
  // Ressourcenplanung (nur SuperAdmin + Kaufmännisch)
  { path: 'ressourcenplanung', component: ResourceTimelineComponent, canActivate: [AuthGuard, ResourcePlanningGuard] },
  // Stammkunden (eigene Personen-Einsatzplanung)
  { path: 'stammkunden', component: StammkundenListComponent, canActivate: [AuthGuard, StammkundenGuard] },
  // Feld-Sicht des Vorarbeiters – VOR der :id-Route, damit "meine-einsaetze" nicht als Id gilt.
  // Eigener Guard: auch der reine Vorarbeiter (ohne Verwaltungszugriff) darf hierher.
  { path: 'stammkunden/meine-einsaetze', component: MeineEinsaetzeComponent, canActivate: [AuthGuard, MeineEinsaetzeGuard] },
  { path: 'stammkunden/:id', component: StammkundeDetailComponent, canActivate: [AuthGuard, StammkundenGuard] },
  { path: 'stammkunden/:id/planung', component: EinsatzPlanungComponent, canActivate: [AuthGuard, StammkundenGuard] },
  { path: 'stammkunden/:id/auftrag/:auftragId', component: AuftragDetailComponent, canActivate: [AuthGuard, StammkundenGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
